import cxs from 'cxs';
import { MEDIA_QUERIES } from '../../../common/styles/vars';

export const CONTENT = cxs({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',

  [MEDIA_QUERIES.small]: {
    paddingLeft: '0px',
    paddingRight: '0px'
  }
});

export const HEADER = ({ showBackBtn }) => cxs({
  marginBottom: '20px',
  marginTop: showBackBtn ? '20px' : void 0
});

export const BACK_ICON = cxs({
  cursor: 'pointer',
  position: 'absolute',
  top: '22px',
  left: '25px'
});